<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Import Recipients from Excel</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="onClickDiscardChanges"
                    >
                        Cancel
                    </v-btn>

                    <v-btn
                        dark
                        text
                        :disabled="!is_valid"
                        @click="onClickSave"
                    >
                        Import
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-container>
                <v-layout>
                    <h2>Valid Rows</h2>
                </v-layout>

                <v-data-table
                    :headers="valid_intermediate_recipient_headers"
                    :items="valid_intermediate_recipients"
                    :items-per-page="25"
                    class="elevation-1"
                    :footer-props="{
                        itemsPerPageOptions: [25, 50, 100, -1],
                    }"
                >
                    <template v-slot:item.should_include="{ item }">
                        <v-simple-checkbox v-ripple="false" v-model="item.include"></v-simple-checkbox>
                    </template>

                    <template v-slot:item.pretty_phone_number="{ item }">
                        {{prettyPrintPhoneNumber(item)}}
                    </template>

                    <template v-slot:item.action="{ item }">
                        <v-menu
                            bottom
                            offset-y
                        >

                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-dots-vertical-circle-outline
                                </v-icon>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-on:click="onClickEditRecipient(item)"
                                >
                                    <v-list-item-title>Edit</v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-on:click="onClickDeleteRecipient(item)"
                                >
                                    <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>

                </v-data-table>

            </v-container>


            <!-- Invalid section -->
            <v-container>
                <v-layout>
                    <h2>Invalid Rows</h2>
                </v-layout>

                <v-data-table
                    :headers="invalid_intermediate_recipient_headers"
                    :items="invalid_intermediate_recipients"
                    :items-per-page="25"
                    class="elevation-1"
                    :footer-props="{
                        itemsPerPageOptions: [25, 50, 100, -1],
                    }"
                >
                    <template v-slot:item.action="{ item }">
                        <v-menu
                            bottom
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    mdi-dots-vertical-circle-outline
                                </v-icon>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-on:click="onClickEditRecipient(item)"
                                >
                                    <v-list-item-title>Edit</v-list-item-title>
                                </v-list-item>

                                <v-list-item
                                    v-on:click="onClickDeleteRecipient(item)"
                                >
                                    <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>

            </v-container>

        </v-card>

        <m-bulk-intermediate-recipient-edit-dialog
            ref="edit-bulk-recipient"
        />
    </v-dialog>
</template>

<script>

const E164 = require("@/js/E164.js");
const { v4: uuidv4 } = require('uuid');

export default {

    data() {
        return {
            dialog: false,
            organization_id: null,
            bulk_message_id: null,
            intermediate_recipients: null,
            extra_fields: [],

            rules: {
                required: (value) => { if ( value == null || value.trim().length == 0 ) return 'Required'; return true;  },
            },
        }
    },

    methods: {

        onClickDeleteRecipient(recipient)
        {
            this.$rc.confirm(
                'Delete Recipient',
                'Are you sure you want to delete this recipient?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Confirm', 'value': 'confirm'},
                ],
                (response) => {

                    if (response == 'confirm') {

                        for ( let i=0; i < this.intermediate_recipients.length; i++ )
                        {
                            if ( this.intermediate_recipients[i].row_number == recipient.row_number )
                            {
                                this.intermediate_recipients.splice(i,1);
                                break;
                            }
                        }

                    } else {
                        return;
                    }
                }
            );
        },

        onClickEditRecipient(recipient)
        {
            this.$refs['edit-bulk-recipient'].showDialog(
                this.organization_id,
                recipient
            );
        },

        prettyPrintPhoneNumber(item)
        {
            return E164.prettyPrintUsPhoneNumber(item.endpoint);
        },

        showDialog(organization_id, bulk_message_id, intermediate_recipients)
        {
            this.dialog = true;

            this.organization_id = organization_id;
            this.bulk_message_id = bulk_message_id;
            this.intermediate_recipients = intermediate_recipients;

            this.prepopulateExtraFields();
        },

        prepopulateExtraFields()
        {
            if ( this.intermediate_recipients.length == 0 )
            {
                return;
            }

            let recipient = this.intermediate_recipients[0];
            this.extra_fields = Object.keys(recipient.ex_fields);
        },

        closeDialog()
        {
            this.dialog = false;
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        save()
        {
            this.$rc.showSpinner();

            this.$rc.bulkRecipientsCommitIntermediate(
                this.organization_id,
                this.bulk_message_id,
                this.intermediate_recipients,
                (data) => {
                    this.$rc.hideSpinner();
                    this.$emit('ok');
                },
                () => {
                    this.$rc.alert(
                        'Error Committing Changes',
                        'An error occurred while attempting to commit the changes. Please try again.'
                    );
                }
            );
        },

        intermediate_recipient_headers(valid) {
            let ret = [];

            ret.push({ text: 'Row', value: 'row_number'});

            if ( valid )
            {
                ret.push({ text: 'Include', value: 'should_include'});
            }

            ret.push({ text: 'First Name', value: 'first_name'});
            ret.push({ text: 'Last Name', value: 'last_name'});

            if ( valid )
            {
                ret.push({ text: 'Phone Number', value: 'pretty_phone_number'});
            }

            if ( this.extra_fields )
            {
                for ( let i=0; i < this.extra_fields.length; i++ )
                {
                    let extra_field = {
                        text: this.extra_fields[i],
                        value: 'extra_field_' + this.extra_fields[i],
                    };

                    ret.push(extra_field);
                }
            }

            ret.push({ text: 'System Notes', value: 'notes'});
            ret.push({ text: 'Action', value: 'action'});

            return ret;
        },
    },
    computed: {
        is_valid() {
            return this.valid_intermediate_recipients.length > 0;
        },

        valid_intermediate_recipient_headers() {
            return this.intermediate_recipient_headers(true);
        },

        invalid_intermediate_recipient_headers() {
            return this.intermediate_recipient_headers(false);
        },

        valid_intermediate_recipients() {
            let ret = [];

            if ( !this.intermediate_recipients )
            {
                return ret;
            }

            for ( let i = 0; i < this.intermediate_recipients.length; i++ )
            {
                if ( this.intermediate_recipients[i].valid )
                {
                    ret.push(this.intermediate_recipients[i]);
                }
            }

            return ret;
        },

        invalid_intermediate_recipients() {
            let ret = [];

            if ( !this.intermediate_recipients )
            {
                return ret;
            }

            for ( let i = 0; i < this.intermediate_recipients.length; i++ )
            {
                if ( !this.intermediate_recipients[i].valid )
                {
                    ret.push(this.intermediate_recipients[i]);
                }
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>